import { err, ok, Result } from 'neverthrow'
import { Schema, ValidationError } from 'yup'

export const safeValidateSync = <ValidationSchema>(
  schema: Schema<ValidationSchema>,
  object: unknown,
): Result<ValidationSchema, ValidationError> => {
  try {
    return ok(schema.validateSync(object))
  } catch (error) {
    return err(error as ValidationError)
  }
}
